import { Link } from 'react-router-dom';

export default function LoggedOutHome() {
    return (
        <>logged out. <Link to="log-in">log in</Link> or <Link to="sign-up">sign up</Link></>
    )
}
